import React from "react";
import Faq from "../components/faq/Faq";
import SurveySlider from "../components/surveySlider/SurveySlider";

function CompanyInfoPage() {
  return (
    <main className="container mx-auto px-4 py-8">
      {/* О компании */}
      <section id="about" className="py-12">
        <h2 className="text-3xl font-bold mb-4">О компании</h2>
        <p className="mb-4">
          Интернет-магазин <strong>Vanil</strong> – это динамично развивающийся бренд в сфере косметики, предлагающий исключительно оригинальную продукцию от ведущих мировых и местных брендов. Мы стремимся предоставить качественные косметические средства, профессиональные консультации и актуальные тренды в мире красоты для наших клиентов.
        </p>
        <p className="mb-4">
          Наша миссия – сделать уход за собой доступным и эффективным, предлагая широкий ассортимент товаров для ухода за кожей, волосами и телом. Мы уделяем особое внимание подбору ассортимента, сотрудничая только с проверенными поставщиками и официальными дистрибьюторами.
        </p>
        <p>
          Более подробную информацию о наших новинках, акциях и специальных предложениях вы можете найти в нашем Instagram:{" "}
          <a
            href="https://www.instagram.com/vanil_kz_/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            @vanil_kz_
          </a>
          .
        </p>
      </section>

      {/* Магазины */}
      <section id="stores" className="py-12">
        <h2 className="text-3xl font-bold mb-4">Магазины</h2>
        <h3 className="text-2xl font-semibold mb-2">Г. Астана (ПРАВЫЙ БЕРЕГ)</h3>
        <ul className="list-disc pl-6 mb-4">
          <li>
            📍{" "}
            <a
              href="https://2gis.kz/astana/search/%D0%9A%D0%B5%D0%BD%D0%B5%D1%81%D0%B0%D1%80%D1%8B%2C%2052%20%D0%B2%D0%B0%D0%BD%D0%B8%D0%BB%D1%8C/firm/70000001038489161/71.442176%2C51.166972?m=71.443112%2C51.130305%2F10.62"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Кенесары 52, ЖК Эдем Палас 2
            </a>
          </li>
          <li>
            📍{" "}
            <a
              href="https://2gis.kz/astana/search/%D0%A1%D0%B0%D0%B3%D0%B0%D0%B4%D0%B0%D1%82%20%D0%9D%D1%83%D1%80%D0%BC%D0%B0%D0%B3%D0%B0%D0%BD%D0%B1%D0%B5%D1%82%D0%BE%D0%B2%D0%B0%2027%20%D0%B2%D0%B0%D0%BD%D0%B8%D0%BB%D1%8C/firm/70000001077377623/71.484755%2C51.120458?m=71.443112%2C51.13141%2F10.61"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Сагадат Нурмаганбетова 27, НП10
            </a>
          </li>
        </ul>
        <h3 className="text-2xl font-semibold mb-2">Г. Астана (ЛЕВЫЙ БЕРЕГ)</h3>
        <ul className="list-disc pl-6 mb-4">
          <li>
            📍{" "}
            <a
              href="https://2gis.kz/astana/search/%D0%A2%D0%BE%D0%BB%D0%B5%20%D0%B1%D0%B8%2057%20%D0%B2%D0%B0%D0%BD%D0%B8%D0%BB%D1%8C/firm/70000001063339464/71.395227%2C51.131816?m=71.443112%2C51.130856%2F10.61"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Толе би 57, ЖК ASYL MURA Al-Farabi
            </a>
          </li>
        </ul>
        <h3 className="text-2xl font-semibold mb-2">Точки самовывоза</h3>
        <ul className="list-disc pl-6 mb-4">
          <li>
            📍{" "}
            <a
              href="https://2gis.kz/astana/search/%D0%A2%D0%BE%D0%BB%D0%B5%20%D0%B1%D0%B8%20152%20%D0%B2%D0%B0%D0%BD%D0%B8%D0%BB%D1%8C/firm/70000001084245428/71.395227%2C51.131816?m=71.443112%2C51.130856%2F10.61"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Толе би 152
            </a>
          </li>
        </ul>
        <p>
          Все магазины работают ежедневно с 10:00 до 22:00.
        </p>
      </section>

      {/* Публичная оферта */}
      <section id="offer" className="py-12">
        <h2 className="text-3xl font-bold mb-4">Публичная оферта</h2>
        <p className="mb-4">
          Настоящая публичная оферта является официальным предложением заключить договор купли-продажи товаров через интернет-магазин <strong>Vanil</strong>.
        </p>
        <p className="mb-4">
          Оформление заказа происходит онлайн. При оформлении заказа вы вводите свои контактные данные, а при заказе доставки указываете адрес доставки. После подтверждения заказа товар отправляется вам.
        </p>
        <p className="mb-4">
          Возврат товара производится только после личной связи с покупателем для согласования деталей возврата. Мы гарантируем 100% оригинальность всей представленной продукции.
        </p>
      </section>

      {/* Политика конфиденциальности */}
      <section id="privacy" className="py-12">
        <h2 className="text-3xl font-bold mb-4">Политика конфиденциальности</h2>
        <p className="mb-4">
          Ознакомьтесь с нашей полной политикой конфиденциальности по следующей ссылке:{" "}
          <a
            href="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            Политика конфиденциальности
          </a>
        </p>
      </section>

      {/* Контакты */}
      <section id="contacts" className="py-12">
        <h2 className="text-3xl font-bold mb-4">Контакты</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>
            <strong>Толе би:</strong>{" "}
            <a
              href="https://wa.me/77474604853"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              77474604853
            </a>
          </li>
          <li>
            <strong>ул. Кенесары:</strong>{" "}
            <a
              href="https://wa.me/77057244351"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              77057244351
            </a>
          </li>
          <li>
            <strong>Толе би:</strong>{" "}
            <a
              href="https://wa.me/77474869006"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              77474869006
            </a>
          </li>
          <li>
            <strong>Нурмаганбетова:</strong>{" "}
            <a
              href="https://wa.me/77071065985"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              77071065985
            </a>
          </li>
        </ul>
        <p>
          Также свяжитесь с нами через Instagram:{" "}
          <a
            href="https://www.instagram.com/vanil_kz_/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            @vanil_kz_
          </a>
        </p>
        <p className="mt-4">
          Электронная почта:{" "}
          <a href="mailto:info@vanilkz.kz" className="text-blue-600 hover:underline">
            info@vanilkz.kz
          </a>
        </p>
        <p className="mt-4">
          Продавец: Индивидуальный предприниматель Конурова Дина Азаматовна, ИИН 951116450102,
          Республика Казахстан, г. Астана, ул. Толе би, 57, НП6, 010007. Телефон:{" "}
          <a href="tel:+77475554668" className="text-blue-600 hover:underline">
            +7 747 555 4668
          </a>
          .
        </p>
      </section>

      {/* Доставка */}
      <section id="delivery" className="py-12">
        <h2 className="text-3xl font-bold mb-4">Доставка</h2>
        <h3 className="text-2xl font-semibold mb-2">По городу</h3>
        <ul className="list-disc pl-6 mb-4">
          <li>Доставка до 10.000 тг — 700 тг</li>
          <li>Доставка от 10.000 тг — бесплатная</li>
        </ul>
        <h3 className="text-2xl font-semibold mb-2">По Казахстану</h3>
        <ul className="list-disc pl-6 mb-4">
          <li>Доставка от 30.000 тг — бесплатная</li>
        </ul>
      </section>

      {/* Оплата */}
      <section id="payment" className="py-12">
        <h2 className="text-3xl font-bold mb-4">Оплата</h2>
        <p>
          Оплата производится посредством выставления счета через Kaspi, а также наличными в магазине при самовывозе.
        </p>
      </section>

      {/* Возвраты / Гарантия */}
      <section id="returns" className="py-12">
        <h2 className="text-3xl font-bold mb-4">Возвраты / Гарантия</h2>
        <p className="mb-4">
          Возврат товара осуществляется индивидуально с покупателем после предварительной связи для согласования условий возврата. Гарантия подтверждается сертификатами оригинальности.
        </p>
        <p>
          Полный порядок отмены заказа, возврата товара и возврата денежных средств описан в разделе{" "}
          <a href="/refund" className="text-pink-500 hover:underline">
            «Условия возврата и отмены платежей»
          </a>
          .
        </p>
      </section>

      {/* Бонусный клуб */}
      <section id="bonus" className="py-12">
        <h2 className="text-3xl font-bold mb-4">Бонусный клуб</h2>
        <p className="mb-4">
          ДАРИМ СКИДКИ – 5% и 10%
        </p>
        <p className="mb-4">
          Совершайте покупку на сумму всего 25.000 тг в любом из наших филиалов (<strong>@vanil_kz_</strong>) и получите постоянную скидочную карту на –5%. При покупке товаров на сумму 50.000 тг вы становитесь обладателем максимальной дисконтной карты –10%, действующей на все последующие покупки. Дисконтной картой могут воспользоваться ваши близкие и друзья, показав фото карты нашим кассирам.
        </p>
        <p className="mb-4">
          Все наши филиалы работают ежедневно с 10:00 до 22:00. Онлайн-заказы оформляются через WhatsApp или Direct, а доставка осуществляется день в день до ваших дверей.
        </p>
        <p>
          Отмечайте нас в Instagram Stories и получайте дополнительную скидку –5% от суммы покупки.
        </p>
      </section>

      {/* FAQ */}
      <section id="faq" className="py-12">
        <h2 className="text-3xl font-bold mb-4">Часто задаваемые вопросы</h2>
        <Faq />
      </section>

      {/* Хранение и уход */}
      <section id="storage" className="py-12">
        <SurveySlider />
      </section>
    </main>
  );
}

export default CompanyInfoPage;
